// eslint-disable

<template>
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 396.15 386.7"
    :width="width"
    :height="height"
  >
    <path
      fill="#2073cf"
      d="M195.99,192.47c-12.03,11.84-24.13,23.61-36.08,35.54-32.73,32.65-65.4,65.37-98.1,98.06-1.41,1.41-2.92,2.7-5.06,4.67C9.21,279.64-10.29,220.16,5.25,152.58,23.61,72.7,74.87,22.07,155.03,4.7c66.84-14.48,125.56,4.99,175.94,52.03-2.19,2.3-3.66,3.92-5.21,5.46-40.97,40.96-81.95,81.9-122.91,122.87-1.96,1.96-3.72,4.11-5.57,6.16-.43,.42-.86,.84-1.29,1.25Z"
    />
    <path
      fill="#2073cf"
      d="M195.99,192.47c.43-.42,.87-.84,1.29-1.25,27.09-.36,54.18-.69,81.27-1.08,10.02-.14,20.04-.43,30.06-.6,25.8-.45,51.6-.88,77.4-1.31,2.92-.05,5.85,0,10.13,0-.94,10.3-1.18,20.1-2.82,29.67-11.11,64.82-45.47,113.43-102.97,145.34-26.2,14.54-54.6,21.79-84.51,23.43-4.86,.27-6.34-.97-6.4-5.99-.61-49.75-1.44-99.5-2.3-149.24-.22-12.99-.76-25.97-1.16-38.96Z"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ExchangeRatesLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
